import * as z from 'zod'

import {buildEntrySchemaFor} from '../entry'
import {buildPageSchemaForTemplate} from './containerPage'
import {PrimerComponentHeroSchema} from './primerComponentHero'
import {PrimerComponentCardSchema} from './primerComponentCard'
import {PrimerComponentSubnavSchema} from './primerComponentSubnav'
import {RichTextSchema} from '../richText'
import {safeOptional} from '../../safe-optional'

export const IndexFilterSchema = buildEntrySchemaFor('indexFilter', {
  fields: z.lazy(() =>
    z.object({
      groupName: z.string(),
      groupValue: z.string(),
      filterName: z.string(),
      filterValue: z.string(),
    }),
  ),
})

export type IndexFilter = z.infer<typeof IndexFilterSchema>

export const IndexCardSchema = buildEntrySchemaFor('indexCard', {
  fields: z.lazy(() =>
    z.object({
      card: safeOptional(PrimerComponentCardSchema),
      indexFilters: safeOptional(z.array(IndexFilterSchema)),
    }),
  ),
})

export type IndexCard = z.infer<typeof IndexCardSchema>

export const TemplateIndexSchema = buildEntrySchemaFor('templateIndex', {
  fields: z.lazy(() =>
    z.object({
      subNav: safeOptional(PrimerComponentSubnavSchema),
      hero: safeOptional(PrimerComponentHeroSchema),
      cards: safeOptional(z.array(IndexCardSchema)),
      filters: safeOptional(z.array(IndexFilterSchema)),
      emptyStateDescription: safeOptional(RichTextSchema),
      spotlightCard: safeOptional(IndexCardSchema),
    }),
  ),
})

export const IndexPageSchema = buildPageSchemaForTemplate(TemplateIndexSchema)
export type IndexPage = z.infer<typeof IndexPageSchema>

export function toIndexPage(item: unknown): IndexPage {
  return IndexPageSchema.parse(item)
}
